import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';

export const Card = styled.div`
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.3);
  padding: 16px;
  background: white;
  border-radius: 8px;
  cursor: pointer;

  img {
    margin: -5px;
    width: calc(100% + 10px);
  }
`;

export const ContentTitle = styled.div`
  color: ${(props) => props.theme.color.dark.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 700;
  ${responsiveFontSize(20, 0.5)};
  margin-top: 14px;
`;

export const ContentSubtitle = styled.div`
  color: ${(props) => props.theme.color.dark.default};
  font-size: 13px;
  margin-top: 8px;
`;

export const Footer = styled.div`
  margin-top: 16px;
`;
